import gql from "graphql-tag";

export const RULES = gql`
  query rules($where: RulesWhereInput) {
    rules(where: $where) {
      data {
        interventionTypes
        faultTypes
        masks
        warrantyTypes
        forms
      }
      count
    }
  }
`;
